/**
 * @module client-api-base
 * @module_directory /modules/client/base
 * @module_path ui
 * @description Navigation main menu
 * @section 4.5
 *
 */
/* eslint-disable react/jsx-no-bind */
import IconButton from "@material-ui/core/IconButton";
import Toolbar from "@material-ui/core/Toolbar";
import clsx from "clsx";
import React, { useEffect, useRef, useState } from "react";
import { useAppContext } from "./../context/AppCtxProvider";
import SidewaysMegamenuDrawer from "./../viewcomponents/SidewaysMegamenuDrawer/SidewaysMegamenuDrawer";
import { makeThemedStyles } from "./../viewcomponents/utils";
import { getFileApiURL } from "./../utils/url-utils";
import HamburgerMenu from "./HamburgerMenu";
import MenuColumn from "./MenuColumn";
export interface Data {
  _id: string;
  title: string;
  enabled: boolean;
  description?: string;
  group?: string | null;
  link: string;
  icon?: string | JSX.Element;
  children: Data[];
  rangecolor?: string;
}
const useStyles = makeThemedStyles("HorizontalMenu", (theme) => ({
  icon: { color: theme.palette.primary.contrastText },
  drawerList: {},
  columnContainer: {
    display: "flex",
    height: "57.6em",
    marginTop: "8em",
  },
  preview: {
    width: "-webkit-fill-available",
    display: "flex",
    alignItems: "center",
    justifyContent: "end",
    marginLeft: "auto",
    animation: `$fadeIn 1s ${theme.transitions.easing.easeInOut}`,
  },
  previewImage: {
    width: "26.62em",
    height: "41.14em",
    borderRadius: "0.914em",
    objectFit: "cover",
  },
  SidewaysMegamenuToolbar: {},
  fadeIn: {
    animation: `$fadeIn 500ms ${theme.transitions.easing.easeInOut}`,
    animationDelay: "100ms",
  },
  fadeOut: {
    animation: `$fadeOut 400ms ${theme.transitions.easing.easeInOut}`,
  },
  "@keyframes fadeIn": {
    "0%": {
      opacity: 0,
    },
    "100%": {
      opacity: 1,
    },
  },
  "@keyframes fadeOut": {
    "0%": {
      opacity: 1,
    },
    "100%": {
      opacity: 0,
    },
  },
}));
interface HorizontalMenuProps {
  tenant: string;
  menuItems?: Data;
  RenderTab?: React.FC<{
    item: Data;
    onClick: () => void;
  }>;
}
const HorizontalMenu = ({
  tenant,
  menuItems,
  RenderTab,
}: HorizontalMenuProps) => {
  const classes = useStyles();
  const [showPreview, setShowPreview] = useState<string | false>(false);
  const rtl = useAppContext((s) => s.rtl);
  const toggleButtonRef = useRef<HTMLButtonElement | null>(null);
  const [open, setOpen] = React.useState(false);
  const [values, setValues] = React.useState<Array<string | boolean>>([]);
  function handleDrawerToggle() {
    setOpen(!open);
  }
  const handleChange = (newValue: string | boolean, level: number) => {
    setShowPreview(typeof newValue === "string" ? newValue : false);
    const newArray = values.slice(0, level).concat(newValue);
    setValues(newArray);
  };
  function closeHandler() {
    setOpen(false);
  }
  useEffect(() => {
    let rightSibling: HTMLElement | null = null;
    const target = toggleButtonRef.current;
    if (target) {
      const parentLeft = target.parentElement as HTMLElement;
      rightSibling = parentLeft.nextSibling as HTMLElement;
    }
    rightSibling?.addEventListener("click", closeHandler);
    return () => rightSibling?.removeEventListener("click", closeHandler);
  }, [toggleButtonRef.current]);
  console.log("Values", values);
  return (
    <>
      <IconButton
        ref={toggleButtonRef}
        className={classes.icon}
        data-testid="sideways-megamenu-drawer-button"
        onClick={handleDrawerToggle}
      >
        <HamburgerMenu open={open} />
      </IconButton>
      <SidewaysMegamenuDrawer
        anchor="top"
        open={open}
        onClose={handleDrawerToggle}
        data-testid="sideways-megamenu-drawer-root"
        transitionDuration={500}
        classes={{
          paper: classes.drawerList,
        }}
      >
        <Toolbar className={classes.SidewaysMegamenuToolbar} />
        <div
          className={clsx(
            classes.columnContainer,
            open ? classes.fadeIn : classes.fadeOut
          )}
          dir={rtl ? "rtl" : "ltr"}
        >
          <MenuColumn
            level={0}
            data={menuItems}
            tenant={tenant}
            values={values}
            handleChange={handleChange}
            toggleMenu={handleDrawerToggle}
            RenderTab={RenderTab}
          />
          {showPreview && (
            <div key={showPreview} className={classes.preview}>
              <img
                className={classes.previewImage}
                style={{
                  margin: rtl ? " 0 0 0 9.82em" : " 0 9.82em 0 0",
                }}
                src={getFileApiURL("/images/MenuPreviewBackground.png")}
                alt="img"
              />
            </div>
          )}
        </div>
      </SidewaysMegamenuDrawer>
    </>
  );
};
export default HorizontalMenu;
